import './style.scss';

import React, { PropTypes } from 'react';

import { CollapsibleItem } from 'routes/app/components';
import VisitHeader from './VisitHeader';
import VisitBody from './VisitBody';

const Visit = ({visit, onDelete, getUnits, ...other}) => (

    <CollapsibleItem header={<VisitHeader {...visit} />}
                     eventKey={visit.trac}
                     onOpen={(vtrac)=>getUnits({vtrac})}>
        <VisitBody {...visit} removeVisit={onDelete} {...other}/>
    </CollapsibleItem>

);

Visit.propTypes = {
    visit: PropTypes.object.isRequired,
    onDelete: PropTypes.func.isRequired,
    getUnits: PropTypes.func.isRequired
};

export default Visit;
